@if (compositeScore !== null && compositeScore !== undefined) {
<div class="composite-score-widget" [class]="'size-' + size">
  <div class="score-widget">
    <h3>{{ title }}</h3>
    <div class="gauge-container">
      <div class="score-gauge">
        <div class="gauge-circle"
          [style.background]="'conic-gradient(' + getScoreColor(getScoreValue()) + ' 0deg ' + (getScoreValue() * 3.6) + 'deg, #e0e0e0 ' + (getScoreValue() * 3.6) + 'deg 360deg)'">
          <div class="gauge-inner">
            <span class="score-value">{{ getScoreValue() }}</span>
            <span class="score-label">{{ getScoreLabel(getScoreValue())}}</span>
          </div>
        </div>
      </div>
      <!-- <div class="brand-name">{{ getBrandName() }}</div> -->
    </div>
  </div>
</div>
}
